import { useRef, useEffect, useState } from 'react';
import s from './style.module.scss';

import MyIcon from '@/components/MyIcon';
import { Display } from '@/components/Display/Display';
const SkillTemplate = ({ templateList, visible, onClose, setTemplate }) => {
    const [activeId, setActiveId] = useState(null);
    const templateRef = useRef();
    //点击弹窗以外的部分，关闭弹窗
    const clickGap = (e) => {
        //如果弹窗未打开，不做任何操作
        if (!templateRef.current) {
            return false;
        }
        //日期组件点击年份的时候，contains不生效，所以在wrapRef上阻止了冒泡
        if (templateRef.current && !templateRef.current.contains(e.target)) {
            onClose();
        }
    };
    useEffect(() => {
        document.body.addEventListener('click', clickGap);
        return () => {
            document.body.removeEventListener('click', clickGap);
        };
    }, []);
    const onClickItem = (item) => {
        setActiveId(item?.id);
        setTemplate(item.template_content);
    };
    useEffect(() => {
        if (!visible) {
            setActiveId(null);
            // setTemplate('');
        }
    }, [visible]);
    return (
        <>
            <Display show={visible}>
                <div ref={templateRef} className={s['template-box']}>
                    <div className={s['mask-wrap']}>
                        <div className={s['mask-title']}>
                            <span>模板</span>
                            <span className={s['close']} onClick={onClose}>
                                <MyIcon className={s['close-icon']} type="icon-a-guanbi31"></MyIcon>
                            </span>
                        </div>
                        <div className={s['mask-list-box']}>
                            {templateList &&
                                templateList.map((item, index) => {
                                    return (
                                        <div
                                            data-active={activeId === item?.id}
                                            className={s['mask-list-item']}
                                            key={index}
                                            onClick={() => onClickItem(item)}
                                        >
                                            <div className={[`${s['template-name']} ellipsis-1`]}>{item.template_name}</div>
                                            <div className={[`${s['template-describe']} ellipsis-1`]}>{item.template_describe}</div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </Display>
        </>
    );
};

export default SkillTemplate;
